
import SVGLoading from '@/assets/placeholder/loading.svg'
import { defineComponent } from 'vue'

export default defineComponent({
  components: {
    SVGLoading
  }
})
